import AnnualUpdateCard from '../Common/AnnualUpdateCard';
import AdminUserManagementCard from '../Common/AdminUserManagementCard';
import TenantNewTermSchoolClassCard from '../Common/TenantNewTermSchoolClassCard';

type Props = {
    tabActiveKey: string;
    hasTouchScreen: boolean;
};

const ControlSetting: React.FC<Props> = ({ hasTouchScreen, tabActiveKey }) => {
    return (
        <div className='container'>
            <AnnualUpdateCard />
            <TenantNewTermSchoolClassCard tabActiveKey={tabActiveKey} />
            <AdminUserManagementCard hasTouchScreen={hasTouchScreen} tabActiveKey={tabActiveKey} />
        </div>
    );
};

export default ControlSetting;
